import React, { useCallback, useMemo } from 'react';
import { connectComponent } from '../../redux/utils';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'grilnica-reactstrap';
import bindErrorActions from '../../redux/action/error';
import { LinksModalContent } from './components/LinksModalContent';
import { A11yFromHelperModalContent } from './components/A11yFromHelperModalContent';
// Модальное окно для отображения глобальной ошибки
var ErrorModal = function (_a) {
    var responseError = _a.responseError, actions = _a.actions;
    var closeModal = useCallback(function () {
        actions.setError(null);
    }, [actions]);
    var renderDefaultModalContent = useMemo(function () {
        if (!(responseError === null || responseError === void 0 ? void 0 : responseError.errorMessage)) {
            return null;
        }
        return (React.createElement("p", { className: 'sec-subtitle1 text-gray900 ' + ((responseError === null || responseError === void 0 ? void 0 : responseError.objectsMap) ? 'mb-x6' : 'mb-0') }, responseError.errorMessage));
    }, [responseError]);
    var renderContent = useMemo(function () {
        var _a, _b;
        var objectsMap = responseError === null || responseError === void 0 ? void 0 : responseError.objectsMap;
        if ((_a = objectsMap) === null || _a === void 0 ? void 0 : _a.links) {
            return (React.createElement(Modal, { isModalAdmin: true, isOpen: !!responseError, onClose: closeModal, size: 'xs', classNameWrapper: 'z-100000' },
                React.createElement(LinksModalContent, { error: responseError, closeModal: closeModal })));
        }
        else if ((_b = objectsMap) === null || _b === void 0 ? void 0 : _b.errorObjectsMap) {
            return (React.createElement(Modal, { isModalAdmin: true, isOpen: !!responseError, onClose: closeModal, size: 'xs', classNameWrapper: 'z-100000' },
                React.createElement(A11yFromHelperModalContent, { error: objectsMap.errorObjectsMap, closeModal: closeModal })));
        }
        else {
            return (React.createElement(Modal, { isModalAdmin: true, isOpen: !!responseError, onClose: closeModal, size: 'xs', classNameWrapper: 'z-100000' },
                React.createElement(ModalHeader, { isModalAdmin: true },
                    React.createElement("p", { className: 'text-head-e-modal mb-0' }, "\u041E\u0448\u0438\u0431\u043A\u0430")),
                React.createElement(ModalBody, { isModalAdmin: true }, renderDefaultModalContent),
                React.createElement(ModalFooter, { isModalAdmin: true },
                    React.createElement(Button, { type: 'button', color: 'primary', size: 'sm', onClick: closeModal }, "\u0417\u0430\u043A\u0440\u044B\u0442\u044C"))));
        }
    }, [closeModal, renderDefaultModalContent, responseError]);
    return React.createElement(React.Fragment, null, renderContent);
};
export default connectComponent(function (state) { return ({
    responseError: state.error.error,
}); }, function (dispatch) { return ({
    actions: bindErrorActions(dispatch),
}); }, ErrorModal);
//# sourceMappingURL=ErrorModal.js.map